export const CATEGORYVIEW_TOP_REQUEST = "CATEGORYVIEW_TOP_REQUEST";
export const CATEGORYVIEW_TOP_ERROR = "CATEGORYVIEW_TOP_ERROR";

// mpseller
export const CHECK_SELLER_CHOICE_EXPIRATION = "CHECK_SELLER_CHOICE_EXPIRATION";
export const RESET_SELLER_CHOICE = "RESET_SELLER_CHOICE";
export const SELLER_FETCHING_REQUESTED = "SELLER_FETCHING_REQUESTED";
export const SELLER_GET_ERROR = "SELLER_GET_ERROR";
export const SELLER_GET_SUCCESS = "SELLER_GET_SUCCESS";
export const SET_SELLER_CHOICE = "SET_SELLER_CHOICE";
export const SET_HAS_OFFLINE_PRODUCTS = "SET_HAS_OFFLINE_PRODUCTS";
export const SET_OFFLINE_AVAILABLE_SELLERS = "SET_OFFLINE_AVAILABLE_SELLERS";
